// extracted by mini-css-extract-plugin
module.exports = {"Loader":"Spinner_Loader__2C0iS","load3":"Spinner_load3__1-S7f"};